import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let submit = useDataSubmit({
    context: 'task',
    viewPath: props.viewPath,
  })

  let description = useDataValue({
    context: 'task_description',
    path: 'description',
    viewPath: props.viewPath,
  })

  let task_id = useDataValue({
    context: 'task',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'set_task_description',
      description,
      task_id,
    })
    setFlowTo(normalizePath(props.viewPath, '../Content'))
  }
}
